import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ReminderResolver } from './shared/resolvers/reminder_resolver';
import { AccountResolver } from './shared/resolvers/account_resolver';
import { WidgetResolver } from './shared/resolvers/widget_resolver';
import { FeatureResolver } from './shared/resolvers/feature_resolver';
import { ENV } from '../environment';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import { HasFeatureResolver } from './shared/resolvers/has_feature_resolver';
import { RedirectService } from '../shared/services/redirect.service';
import { LogService } from '../shared/services/log.service';
import { ShopifyResolver } from './shared/resolvers/shopify_resolver';
import { LaunchDarklyResolver } from './shared/resolvers/launch_darkly_resolver';

@Injectable()
export class InstallResolve implements Resolve<any> {

  constructor(
    private reminderResolver: ReminderResolver,
    private accountResolver: AccountResolver,
    private widgetResolver: WidgetResolver,
    private featureResolver: FeatureResolver,
    private redirectService: RedirectService,
    private hasFeatureResolver: HasFeatureResolver,
    private shopifyResolver: ShopifyResolver,
    private launchDarklyResolver: LaunchDarklyResolver,
    private log: LogService
  ) {}

  resolve() {
    return Observable.forkJoin(
      this.reminderResolver.init(), this.accountResolver.init(), this.widgetResolver.init(), this.featureResolver.init(), this.hasFeatureResolver.init(),
      this.shopifyResolver.init(), this.launchDarklyResolver.init()
    ).catch((response) => {
      this.log.error(response);
      this.redirectService.redirectTo(ENV.YotpoNewB2bEndpoint + '#/login');
      return new EmptyObservable();
    });
  }
}
